/* eslint-disable no-console */
import {Col, Form, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useContext, useEffect, useState} from 'react';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors} from '../../constants/Common';
import {ISelect} from '../../interface/ISelect';
import SelectedCountryContext from '../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import {sortYearOptions} from '../../pages/orgManager/Utils/InfraStructureProfile/constant/sorYear';
import yearFilterArray from '../../shared/YearFilterArray';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import useUserStore from '../../store/userStore/userStore';
import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import FormListComp from '../DrawerForm/Utils/FormListComp';

import {facilityKeyLabel, yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {upstreamKey, upstreamLabel} from './Constants/IP/UpstreamKeyLabel';
import {filterSelectOptions} from './Utils/commonFunctions';
import UpstreamList from './Utils/TableListForm/UpstreamList';

const UpstreamForm: React.FC<{
  setSubmitDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  suppliers: ISelect[];
  type?: 'up' | 'down';
  currentStep?: number;
  setFormFacility: React.Dispatch<React.SetStateAction<string>>;
  setFormSelectedYear: React.Dispatch<React.SetStateAction<string>>;
  defaultDisplayStep?: boolean;
}> = ({
  suppliers = [],
  type = 'up',
  currentStep,
  setFormFacility,
  setFormSelectedYear,
  defaultDisplayStep = false
}) => {
  const isCompanyUserOrAdmin =
    hasUserRole(UserRole.Company_Admin) || hasUserRole(UserRole.Company_user);
  const FormInstance = useFormInstance();
  const {setFields, getFieldValue} = FormInstance;
  const facilityDetails = useCompanyStore.getState().facilityDetails;
  const userDetails = useUserStore.getState().userDetails;
  const mode = useJSONStore.getState().modeOfTransport;
  const [formSelectedCountry, setFormSelectedCountry] = useState<string>('');
  const [facilityOpt, setFacilityOpt] = useState<any[]>([]);
  const {efdbData, facilityId, selectedYear, selectedCountry} = useContext(
    SelectedCountryContext
  );
  const [facilityEfdb, setFacilityEfdb] = useState<any>();

  useEffect(() => {
    setFacilityOpt(
      facilityDetails?.[
        getFieldValue(yearKeyLabel.key) ?? selectedYear ?? ''
      ]?.filter((item: any) => {
        return !item.isLeased;
      }) ?? []
    );
    setFacilityEfdb(
      efdbData?.[getFieldValue(yearKeyLabel.key) ?? selectedYear ?? '']?.find(
        (i: any) => {
          return (
            i.facilityId === (getFieldValue(facilityKeyLabel.key) ?? facilityId)
          );
        }
      )
    );
  }, []);

  useEffect(() => {
    setFormSelectedCountry(
      facilityOpt.find((item: any) => {
        return (
          item?._id === (getFieldValue(facilityKeyLabel.key) ?? facilityId)
        );
      })?.country
    );
  }, [facilityOpt]);

  const [yearOptions, setYearOptions] = useState<any[]>([]);

  useEffect(() => {
    setYearOptions(
      yearFilterArray(
        facilityDetails,
        !isCompanyUserOrAdmin ? userDetails?.facility : undefined,
        false
      )
    );
  }, []);

  // const {setSelectedCountry} = useContext(SelectedCountryContext);

  return (
    <>
      {currentStep === 0 && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              initialValue={selectedYear}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={sortYearOptions(yearOptions)}
                suffixIcon={<YearCalender />}
                disabled={getFieldValue('_id') !== undefined}
                onChange={(e) => {
                  setFormSelectedYear(e);
                  setFacilityOpt(
                    facilityDetails?.[e]?.filter((item: any) => {
                      return !item.isLeased;
                    }) ?? []
                  );
                  setFacilityEfdb(() => {
                    return efdbData?.[e]?.find((i: any) => {
                      return (
                        i?.facilityId === getFieldValue(facilityKeyLabel.key)
                      );
                    });
                  });
                  if (getFieldValue(facilityKeyLabel.key)) {
                    setFields([
                      {
                        name: facilityKeyLabel.key,
                        value: undefined,
                        errors: ['Please select facility again']
                      }
                    ]);
                  }
                }}
              />
            </Form.Item>
          </Col>
          {isCompanyUserOrAdmin && (
            <>
              <Col className="gutter-row">
                <Form.Item
                  name={facilityKeyLabel.key}
                  label={facilityKeyLabel.label}
                  labelCol={{span: 24}}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(facilityKeyLabel.label)
                    }
                  ]}
                  initialValue={facilityId}
                >
                  <Select
                    placeholder={facilityKeyLabel.label}
                    options={
                      facilityOpt?.map((item: any) => {
                        return {label: item.name, value: item._id};
                      }) ?? []
                    }
                    disabled={getFieldValue('_id') !== undefined}
                    onChange={(e) => {
                      setFormFacility(e);
                      setFormSelectedCountry(
                        facilityDetails?.[
                          getFieldValue(yearKeyLabel.key) ?? ''
                        ]?.find((item: any) => {
                          return item._id === e;
                        })?.country
                      );
                      if (getFieldValue(upstreamKey.PRODUCT_DATA)) {
                        if (
                          Array.isArray(getFieldValue(upstreamKey.PRODUCT_DATA))
                        ) {
                          setFields(
                            getFieldValue(upstreamKey.PRODUCT_DATA).map(
                              (_: any, index: number) => ({
                                name: [
                                  upstreamKey.PRODUCT_DATA,
                                  index,
                                  upstreamKey.MODE
                                ],
                                value: undefined,
                                errors: [CommonErrors.selectAgain]
                              })
                            )
                          );
                        }
                      }

                      setFacilityEfdb(() => {
                        return efdbData?.[
                          getFieldValue(yearKeyLabel.key)
                        ]?.find((i: any) => {
                          return i?.facilityId === e;
                        });
                      });
                      if (getFieldValue(upstreamKey.SUPPLIER)) {
                        setFields([
                          {
                            name: upstreamKey.SUPPLIER,
                            errors: [CommonErrors.selectAgain],
                            value: undefined
                          }
                        ]);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </>
      )}
      {(currentStep === 1 || defaultDisplayStep) && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={upstreamKey.SUPPLIER}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(upstreamLabel.SUPPLIER)
                }
              ]}
              label={upstreamLabel.SUPPLIER}
              initialValue={undefined}
              labelCol={{span: 24}}
            >
              <Select
                showSearch
                className="input"
                placeholder={`Choose ${upstreamLabel.SUPPLIER}`}
                filterOption={filterSelectOptions}
                options={suppliers
                  .map((item: any) => {
                    return item;
                  })
                  .sort((a: any, b: any) => {
                    return a.label < b.label ? -1 : 1;
                  })}
              />
            </Form.Item>
          </Col>
          <div className="stepTitle" style={{margin: '2rem 0 0 0'}}>
            Add Details
          </div>
          <FormListComp
            mainName={upstreamKey.PRODUCT_DATA}
            formComponent={
              <UpstreamList
                type={type}
                formSelectedCountry={formSelectedCountry ?? selectedCountry}
                modeOfTransport={mode.filter(
                  (item) => item?.dbName === facilityEfdb?.scope3
                )}
              />
            }
          />
        </>
      )}
    </>
  );
};

export default UpstreamForm;
